(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-monster-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var QUESTIONS = [
      { q: 'Ta soirée idéale le 31 octobre ?', a: [
        ['Un bal masqué aux chandelles', { vampire: 2, dandy: 1 }],
        ['Un feu de camp au fond des bois', { sorciere: 2, faucheuse: 1 }],
        ['Un vieux manoir où l’on se perd', { reine: 2, medecin: 1, mariee: 1 }],
        ['Faire sursauter tout le monde', { faucheuse: 2, medecin: 1, mariee: 1 }]
      ] },
      { q: 'Ta couleur, c’est…', a: [
        ['Le noir absolu', { faucheuse: 2, reine: 1 }],
        ['Le rouge sang', { vampire: 2 }],
        ['Le bordeaux ou le violet', { sorciere: 2, reine: 1 }],
        ['L’or, le brocart… ou le gris des fantômes', { dandy: 2, mariee: 1 }]
      ] },
      { q: 'Ton arme secrète ?', a: [
        ['Un regard qui hypnotise', { vampire: 2, reine: 1 }],
        ['Un sortilège bien placé', { sorciere: 2 }],
        ['Une faux, tout simplement', { faucheuse: 2 }],
        ['Le mystère : personne ne voit ton visage', { medecin: 2, mariee: 1 }]
      ] },
      { q: 'En soirée, on te remarque pour…', a: [
        ['Ta prestance de souveraine', { reine: 2, dandy: 1 }],
        ['Ton élégance d’un autre siècle', { dandy: 2, vampire: 1 }],
        ['Ton côté franchement inquiétant', { medecin: 2, faucheuse: 1, mariee: 1 }],
        ['Ton aura mystique', { sorciere: 2 }]
      ] },
      { q: 'Ta silhouette préférée ?', a: [
        ['Une longue robe qui flotte', { sorciere: 1, reine: 1, mariee: 1 }],
        ['Un long manteau et une capuche', { medecin: 2, faucheuse: 1 }],
        ['Une redingote et une chemise à jabot', { vampire: 1, dandy: 2 }],
        ['Un voile, de la dentelle et des fleurs fanées', { mariee: 3 }]
      ] },
      { q: 'Et cette année, tu sors…', a: [
        ['En duo, costumes assortis', { vampire: 2, mariee: 1 }],
        ['Seul·e : je règne', { reine: 2, faucheuse: 1 }],
        ['Avec tout mon cercle', { sorciere: 1, medecin: 1, dandy: 1 }],
        ['Là où on ne m’attend pas', { faucheuse: 1, medecin: 1, sorciere: 1, mariee: 1 }]
      ] }
    ];
    var RESULTS = {
      vampire: { title: 'Le vampire aristocrate', text: 'Charmeur, élégant, un brin dangereux : tu entres dans la pièce et tout le monde se tait. Une redingote, une chemise à jabot, du rouge sang… et, pourquoi pas, une moitié assortie.', products: ['la-redingote-du-vampire', 'la-chemise-du-poete', 'le-comte-ecarlate', 'le-seigneur-de-minuit', 'la-dame-de-minuit'] },
      reine: { title: 'La reine des ténèbres', text: 'Tu ne demandes pas l’attention : elle te revient de droit. Une robe de cour ou une longue robe noire, un diadème, et la soirée t’appartient.', products: ['la-reine-des-tenebres', 'la-robe-de-la-dame-du-manoir', 'la-robe-de-velours-de-la-nuit', 'la-couronne-de-la-reine-noire'] },
      sorciere: { title: 'La sorcière des corbeaux', text: 'Mystique et indépendante, tu connais les secrets des bois et ceux des invités. Une robe aux manches de dentelle, un chapeau pointu : le sort est jeté.', products: ['la-robe-de-la-sorciere-des-brumes', 'la-dame-des-corbeaux', 'le-chapeau-de-la-sorciere-noire', 'voile-des-trepasses'] },
      faucheuse: { title: 'La grande faucheuse', text: 'Peu de mots, beaucoup d’effet. Tu préfères qu’on te découvre dans un coin sombre… et qu’on s’en souvienne longtemps.', products: ['la-grande-faucheuse', 'le-manteau-du-medecin-de-la-peste'] },
      dandy: { title: 'Le dandy infernal', text: 'Le brocart, les basques longues, le mot juste au bon moment : tu es le diable le mieux habillé de la soirée.', products: ['le-duc-infernal', 'la-redingote-du-vampire', 'la-chemise-du-poete'] },
      medecin: { title: 'Le médecin de la peste', text: 'Personne ne voit ton visage, tout le monde se demande qui tu es. Le mystère est ton meilleur costume.', products: ['le-manteau-du-medecin-de-la-peste', 'le-bec-du-medecin-noir', 'voile-des-trepasses'] },
      mariee: { title: 'La mariée du cimetière', text: 'Ton voile a traversé les siècles et ta noce n’a jamais vraiment pris fin. Douce de loin, glaçante de près : personne n’oubliera ton entrée.', products: ['la-mariee-du-cimetiere', 'les-gants-de-dentelle', 'la-robe-de-la-veuve-noire'] }
    };

    function el(tag, cls, text) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (text != null) e.textContent = text;
      return e;
    }

    function init(root) {
      if (root.dataset.mnReady) return;
      root.dataset.mnReady = '1';
      var stage = root.querySelector('[data-mn-quiz-stage]');
      var bar = root.querySelector('[data-mn-quiz-bar]');
      var count = root.querySelector('[data-mn-quiz-count]');
      var products = {};
      try { products = JSON.parse(root.querySelector('[data-mn-quiz-products]').textContent); } catch (e) { products = {}; }
      var answers = [];
      var started = false;

      function progress(i) {
        bar.style.transform = 'scaleX(' + (i / QUESTIONS.length) + ')';
      }

      function focusHeading(h) {
        if (!started) return;
        h.setAttribute('tabindex', '-1');
        try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); }
      }

      function showQuestion(i) {
        stage.textContent = '';
        progress(i);
        count.textContent = 'Question ' + (i + 1) + ' sur ' + QUESTIONS.length;
        var step = el('div', 'mn-quiz__step');
        var h = el('h3', 'mn-quiz__q', QUESTIONS[i].q);
        step.appendChild(h);
        var ul = el('ul', 'mn-quiz__answers');
        ul.setAttribute('role', 'list');
        QUESTIONS[i].a.forEach(function (ans, k) {
          var li = el('li');
          var b = el('button', 'mn-quiz__answer', ans[0]);
          b.type = 'button';
          b.addEventListener('click', function () {
            started = true;
            answers[i] = k;
            if (i + 1 < QUESTIONS.length) showQuestion(i + 1);
            else showResult(compute());
          });
          li.appendChild(b);
          ul.appendChild(li);
        });
        step.appendChild(ul);
        if (i > 0) {
          var back = el('button', 'mn-quiz__back', 'Question précédente');
          back.type = 'button';
          back.addEventListener('click', function () { showQuestion(i - 1); });
          step.appendChild(back);
        }
        stage.appendChild(step);
        focusHeading(h);
      }

      function compute() {
        var score = {};
        Object.keys(RESULTS).forEach(function (k) { score[k] = 0; });
        answers.forEach(function (k, i) {
          var pts = QUESTIONS[i].a[k][1];
          Object.keys(pts).forEach(function (m) { score[m] += pts[m]; });
        });
        var best = null;
        Object.keys(score).forEach(function (m) {
          if (best === null || score[m] > score[best]) best = m;
        });
        return best;
      }

      function showResult(key) {
        var r = RESULTS[key];
        if (!r) return showQuestion(0);
        stage.textContent = '';
        progress(QUESTIONS.length);
        count.textContent = 'Ton résultat';
        var step = el('div', 'mn-quiz__step');
        var h = el('h3', 'mn-quiz__result-title', 'Tu es… ' + r.title.charAt(0).toLowerCase() + r.title.slice(1));
        step.appendChild(h);
        step.appendChild(el('p', 'mn-quiz__result-text', r.text));
        var ul = el('ul', 'mn-quiz__cards');
        ul.setAttribute('role', 'list');
        var n = 0;
        r.products.forEach(function (handle) {
          var p = products[handle];
          if (!p || n >= 4) return;
          var li = el('li', 'mn-quiz__card');
          li.style.animationDelay = (n * 80) + 'ms';
          n++;
          var a = el('a');
          a.href = p.url;
          if (p.image) {
            var img = el('img');
            img.src = p.image;
            img.alt = p.alt || p.title;
            img.loading = 'lazy';
            img.width = 360;
            img.height = 480;
            a.appendChild(img);
          }
          a.appendChild(el('span', 'mn-quiz__card-title', p.title));
          a.appendChild(el('span', 'mn-quiz__card-price', p.price));
          li.appendChild(a);
          ul.appendChild(li);
        });
        if (n) step.appendChild(ul);
        var actions = el('div', 'mn-quiz__actions');
        var again = el('button', 'button button-secondary', 'Recommencer');
        again.type = 'button';
        again.addEventListener('click', function () { answers = []; showQuestion(0); });
        actions.appendChild(again);
        if (navigator.share) {
          var share = el('button', 'button', 'Partager mon résultat');
          share.type = 'button';
          share.addEventListener('click', function () {
            var url = location.origin + location.pathname + '?monstre=' + key;
            navigator.share({ title: 'Quel monstre es-tu ?', text: 'Je suis ' + r.title.toLowerCase() + ' ! Et toi ?', url: url }).catch(function () {});
          });
          actions.appendChild(share);
        }
        step.appendChild(actions);
        stage.appendChild(step);
        focusHeading(h);
      }

      var shared = /[?&]monstre=([a-z]+)/.exec(location.search);
      if (shared && RESULTS[shared[1]]) showResult(shared[1]);
      else showQuestion(0);
    }

    function boot() { document.querySelectorAll('[data-mn-quiz]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-size-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function num(v) {
      var n = parseFloat(String(v || '').replace(',', '.'));
      return isFinite(n) && n > 0 ? n : null;
    }
    /* Chaque règle renvoie { size, why } ou { size: null, why } (= nous écrire).
       sizes : ordre croissant ; on saute les tailles en rupture. */
    function firstAvailable(order, startIndex, avail) {
      for (var i = startIndex; i < order.length; i++) {
        if (avail[order[i]] === true) return order[i];
      }
      return null;
    }
    function byMax(order, maxima, value, avail) {
      for (var i = 0; i < order.length; i++) {
        if (value <= maxima[i]) return firstAvailable(order, i, avail);
      }
      return null;
    }
    var RULES = {
      'le-comte-ecarlate': function (m, a) {
        if (!m.chest) return { size: null, why: 'Indique ton tour de poitrine.' };
        var s = byMax(['S', 'M', 'L', 'XL', 'XXL'], [97, 104, 112, 119, 127], m.chest, a);
        return { size: s, why: 'D’après le tour de poitrine (tableau des mensurations du corps).' };
      },
      'la-reine-des-tenebres': function (m, a) {
        if (!m.chest) return { size: null, why: 'Indique ton tour de poitrine.' };
        var s = byMax(['S', 'M', 'L', 'XL', 'XXL'], [98, 104, 110, 116, 122], m.chest, a);
        return { size: s, why: 'D’après le tour de poitrine.' };
      },
      'la-grande-faucheuse': function (m, a) {
        if (!m.height) return { size: null, why: 'Indique ta hauteur.' };
        var s = byMax(['S', 'M', 'L', 'XL'], [160, 170, 180, 195], m.height, a);
        return { size: s, why: 'D’après ta hauteur (la robe se porte ample).' };
      },
      'le-duc-infernal': function (m, a) {
        if (!m.chest) return { size: null, why: 'Indique ton tour de poitrine.' };
        var s = byMax(['S', 'M', 'L', 'XL', 'XXL'], [97, 102, 107, 112, 117], m.chest, a);
        return { size: s, why: 'D’après le tour de poitrine maximal conseillé pour la veste.' };
      },
      'le-seigneur-de-minuit': function (m, a) {
        if (!m.height) return { size: null, why: 'Indique ta hauteur.' };
        if (m.height < 165) return { size: null, why: 'Le fabricant prévoit ce costume à partir d’environ 170 cm.' };
        var s = byMax(['M', 'L', 'XL'], [175, 180, 186], m.height, a);
        return { size: s, why: 'D’après ta hauteur.' };
      },
      'la-dame-de-minuit': function (m, a) {
        if (!m.height) return { size: null, why: 'Indique ta hauteur.' };
        if (m.height < 155) return { size: null, why: 'Le fabricant prévoit ce costume à partir d’environ 158 cm.' };
        var order = ['M', 'L', 'XL'];
        var i = 0;
        var maxH = [165, 170, 176];
        while (i < order.length && m.height > maxH[i]) i++;
        /* gilet : poitrine du vêtement à plat 45 / 47 / 49 cm, soit 90 / 94 / 98 cm de tour */
        var garment = [90, 94, 98];
        if (m.chest) { while (i < order.length && m.chest > garment[i]) i++; }
        if (i >= order.length) return { size: null, why: 'Tes mesures dépassent le tableau du fabricant.' };
        return { size: firstAvailable(order, i, a), why: m.chest ? 'D’après ta hauteur et la largeur du gilet.' : 'D’après ta hauteur (ajoute ton tour de poitrine pour vérifier le gilet).' };
      },
      'la-dame-des-corbeaux': function (m, a) {
        if (!m.chest) return { size: null, why: 'Indique ton tour de poitrine.' };
        var order = ['S', 'M', 'L', 'XL', 'XXL'];
        var chest = [100, 104, 108, 112, 116];
        var hips = [106, 122, 128, 134, 140];
        var i = 0;
        /* 4 cm d'aisance minimum sur la mesure du vêtement */
        while (i < order.length && m.chest + 4 > chest[i]) i++;
        if (m.hips) { while (i < order.length && m.hips + 4 > hips[i]) i++; }
        if (i >= order.length) return { size: null, why: 'Tes mesures dépassent le tableau du fabricant.' };
        return { size: firstAvailable(order, i, a), why: 'D’après les mesures de la robe, avec un peu d’aisance.' };
      }
    };

    function init(root) {
      var form = root.querySelector('[data-mn-size-form]');
      var out = root.querySelector('[data-mn-size-results]');
      var dataEl = root.querySelector('[data-mn-size-products]');
      if (!form || !out || !dataEl || form.dataset.mnReady) return;
      form.dataset.mnReady = '1';
      var products = {};
      try { products = JSON.parse(dataEl.textContent); } catch (e) { products = {}; }

      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var m = {
          height: num(form.elements.height.value),
          chest: num(form.elements.chest.value),
          hips: num(form.elements.hips.value)
        };
        out.textContent = '';
        if (!m.height && !m.chest) {
          var p = document.createElement('p');
          p.className = 'mn-size__msg';
          p.textContent = 'Indique au moins ta hauteur ou ton tour de poitrine.';
          out.appendChild(p);
          return;
        }
        var list = document.createElement('ul');
        list.className = 'mn-size__list';
        list.setAttribute('role', 'list');
        var n = 0;
        Object.keys(RULES).forEach(function (handle) {
          var prod = products[handle];
          if (!prod) return;
          var res = RULES[handle](m, prod.available || {});
          var li = document.createElement('li');
          li.className = 'mn-size__item';
          li.style.animationDelay = (n * 60) + 'ms';
          n++;
          var a = document.createElement('a');
          a.href = prod.url;
          a.textContent = prod.title;
          var badge = document.createElement('span');
          badge.className = 'mn-size__badge';
          badge.textContent = res.size ? 'Taille ' + res.size : 'Écris-nous';
          var why = document.createElement('p');
          why.className = 'mn-size__why';
          why.textContent = res.size ? res.why : (res.why || 'Aucune taille disponible ne correspond : écris-nous, on cherche avec toi.');
          li.appendChild(a);
          li.appendChild(badge);
          li.appendChild(why);
          list.appendChild(li);
        });
        out.appendChild(list);
      });
    }

    function boot() {
      document.querySelectorAll('.mn-size').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
